import React, { useState } from "react";
import { Button, Stack, Typography, Modal } from "@mui/material";

import { History } from "./History";
import { useDealRatingSelect } from "store";
interface Props {
  disablePopup?: boolean;
  isAdmin: boolean;
  onCreateSubmit: () => void;
}

export const Rating: React.FC<Props> = ({ isAdmin, disablePopup, onCreateSubmit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rating = useDealRatingSelect();

  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Button
        sx={{
          color: "#5d7782",
          padding: "0 10px",
          minWidth: "auto",
          fontSize: "15px",
          backgroundColor: "#edf1f9",
          minHeight: "28px",
          maxHeight: "28px"
        }}
        onClick={() => !disablePopup && setIsOpen(true)}
      >
        <Stack
          direction="row"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            maxWidth: "200px",
            fontSize: "12px",
            fontWeight: "400"
          }}
          gap="5px"
        >
          <Typography sx={{ color: "#496682" }}>Rating:</Typography>
          <Typography sx={{ color: "#071F35", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
            {rating || "N/A"}
          </Typography>
        </Stack>
      </Button>
      {!disablePopup && (
        <Modal open={isOpen} onClose={handleClose}>
          <History onClose={handleClose} onCreateSubmit={onCreateSubmit} viewOnly={!isAdmin} />
        </Modal>
      )}
    </>
  );
};
